"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CautionText = CautionText;
var jsx_runtime_1 = require("react/jsx-runtime");
// ================================================================
// v2/components/CautionText/index.tsx
// Figma: CautionText — フォームやセクションの補足・注意文。
//
// Figma のコンポーネント説明にある使い分け:
//   軽い注意・補足           → 背景なし (variant='plain')
//   必須アクションに直結する → 背景色あり (variant='filled')
//
// tone:
//   normal (既定) — foreground.neutral.secondary。認知しなくてもよい補足事項
//   info          — foreground.neutral.primary / 面 background.info.subtle
//   error         — foreground.semantic.error。入力エラーや受付期間外など
//
// filled のときはアイコン + 本文の 2 カラムで、本文だけが折り返す。
//
// 色は theme.palette.v2 (useV2Palette) から取得する。
// ================================================================
var material_1 = require("@mui/material");
var theme_1 = require("../../theme");
var tokens_1 = require("../../tokens");
var Icons_1 = require("../Icons");
function CautionText(_a) {
    var children = _a.children, _b = _a.tone, tone = _b === void 0 ? 'normal' : _b, _c = _a.variant, variant = _c === void 0 ? 'plain' : _c, icon = _a.icon;
    var p = (0, theme_1.useV2Palette)();
    var color = tone === 'error'
        ? p.foreground.semantic.error
        : tone === 'info'
            ? p.foreground.neutral.primary
            : p.foreground.neutral.secondary;
    if (variant === 'plain') {
        return ((0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({}, tokens_1.textStyles.body), { lineHeight: "".concat(tokens_1.lineHeight.sm, "px"), color: color, whiteSpace: 'pre-wrap' }), children: children }));
    }
    var backgroundColor = tone === 'error'
        ? p.background.error.subtle
        : tone === 'info'
            ? p.background.info.subtle
            : p.background.neutral.default;
    var iconNode = icon !== null && icon !== void 0 ? icon : (tone === 'info' ? (0, jsx_runtime_1.jsx)(Icons_1.InfoIcon, {}) : undefined);
    return ((0, jsx_runtime_1.jsxs)(material_1.Stack, { direction: "row", alignItems: "flex-start", spacing: "".concat(tokens_1.spacing.xs, "px"), sx: {
            boxSizing: 'border-box',
            width: '100%',
            p: "".concat(tokens_1.spacing.sm + tokens_1.spacing.xs, "px"),
            borderRadius: "".concat(tokens_1.radius.xs, "px"),
            backgroundColor: backgroundColor,
        }, children: [iconNode && ((0, jsx_runtime_1.jsx)(material_1.Box, { sx: {
                    flexShrink: 0,
                    display: 'flex',
                    color: color,
                    '& > *': { fontSize: 20 },
                }, children: iconNode })), (0, jsx_runtime_1.jsx)(material_1.Typography, { component: "div", sx: __assign(__assign({ flex: '1 1 0%', minWidth: 0 }, tokens_1.textStyles.caption), { lineHeight: "".concat(tokens_1.lineHeight.xs, "px"), color: color, whiteSpace: 'pre-wrap' }), children: children })] }));
}
